import InputCatalogoCuentas from '../../util/Inputs/InputCatalogoCuentas';
import SelectIndicadorITBIS from '../../util/Inputs/SelectIndicadorITBIS';
import instanciaAxios from '../../../miscelaneo/instanciaAxios';

// Mapeo de indicador a tasa para cálculo de impuesto
const TASAS_ITBIS = { 1: 18, 2: 16, 3: 0, 4: 0 };

const FuncionesInventario = () => {
        
        const generarCamposFormulario = (unidades_medida =[], categorias, marcas, tipos_producto, impuestos, nombresCuentas, indicadorFacturacionActual = 1) => {
            
            if (!nombresCuentas || typeof nombresCuentas !== 'object') {
                nombresCuentas = {}; // Si es undefined o null, lo inicializa como un objeto vacío
              }

            return[
            // { id: "id_tipo_producto",
            //     type: "select", 
            //     label: "Tipo de producto", 
            //     seccion: "Información del producto", 
            //     options: tipos_producto.map(tipos => ({ label: tipos.descripcion, value: tipos.id_tipo_producto })),
            //     tab: "general" },
            { id: "descripcion", type: "text", label: "Descripción", placeholder: "Descripción", seccion: "Información del producto", tab: "general", required: true },
            { id: "referencia", type: "text", label: "Referencia", placeholder: "Referencia", seccion: "Información del producto", tab: "general" },
            { id: "codigo_barra", type: "text", label: "Código de barras", placeholder: "Código de barras", seccion: "Información del producto", tab: "general", pesableDisabled: true },
            { id: "venta_negativo", type: "checkbox", label: "Venta con existencia negativa", seccion: "Configuración", tab: "general" },
            { id: "es_pesable", type: "checkbox", label: "Producto pesable (balanza)", seccion: "Configuración", tab: "general" },
            { id: "origen", type: "select", label: "Uso Comercial", seccion: "Configuración", tab: "general", options: [{label: 'Ambos', value: 1},{label: 'Compra', value: 2},{label: 'Venta', value: 3}] },
            { id: "costo_inicial", type: "number", label: "Costo Referencia", placeholder: "Costo inicial", seccion: "Costos", tab: "general", required: false}, // Este campo en la interfaz tendrá el nombre de costo Referencia pero en el 
            { id: "costo_ultimo", type: "number", label: "Costo último", placeholder: "Costo último", seccion: "Costos", tab: "general", disabled: true  },
            { id: "costo_promedio", type: "number", label: "Costo promedio", placeholder: "Costo promedio", seccion: "Costos", tab: "general", disabled: true  },
            { id: "precio", type: "number", label: "Precio (Sin impuestos)", placeholder: "Precio", seccion: "Precios", tab: "general", required: true },
            {
                id: "indicador_facturacion",
                label: "ITBIS",
                seccion: "Precios",
                tab: "general",
                custom2: (valorActual, onChange, disabled) => (
                  <SelectIndicadorITBIS
                    value={valorActual !== null && valorActual !== undefined ? valorActual : (indicadorFacturacionActual !== null && indicadorFacturacionActual !== undefined ? indicadorFacturacionActual : 1)}
                    onChange={({ indicador_facturacion }) => onChange(indicador_facturacion)}
                    disabled={disabled}
                  />
                ),
              }, 
            { id: "precio_total", type: "number", label: "Precio total (con impuestos)", placeholder: "Precio total", seccion: "Precios", tab: "general" },
            { id: "existencia_total", type: "number", label: "Existencia total", placeholder: "Existencia total", seccion: "Inventario", tab: "general",  tab: "inventario", disabled: true },
            //{ id: "valor_total_inventario", type: "number", label: "Valor total inventario", placeholder: "Valor total inventario", seccion: "Inventario", tab: "inventario", disabled: true },
            {
              id: "id_cuenta_contable_venta_contado",
              label: "Cuenta de venta al contado",
              seccion: "Contabilidad",
              tab: "general",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_venta_contado"]}
                  placeholder="Seleccionar cuenta de venta al contado"
                />
              ),
            },
            {
              id: "id_cuenta_contable_venta_credito",
              label: "Cuenta de venta a crédito",
              seccion: "Contabilidad",
              tab: "general",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_venta_credito"]}
                  placeholder="Seleccionar cuenta de venta a crédito"
                />
              ),
            },
            {
              id: "id_cuenta_contable_costo",
              label: "Cuenta de costo",
              seccion: "Contabilidad",
              tab: "general",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_costo"]}
                  placeholder="Seleccionar cuenta de venta"
                />
              ),
            },
            {
              id: "id_cuenta_contable_inventario",
              label: "Cuenta de inventario(N/A para servicios)",
              seccion: "Contabilidad",
              tab: "general",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_inventario"]}
                  placeholder="Seleccionar cuenta de inventario"
                />
              ),
            },
            { id: "id_unidad_medida", 
              type: "select", 
              label: "Unidad de medida", 
              seccion: "Información del producto", 
              options: unidades_medida.map(unidad => ({ label: unidad.descripcion, value: unidad.id_unidad_medida })),
              tab: "general",
              required: true },
            { id: "id_categoria",
              type: "select",
              label: "Categoría", 
              seccion: "Información del producto", 
              options: categorias.map(categoria => ({ label: categoria.descripcion, value: categoria.id_categoria })),
              tab: "general" },
            { id: "id_marca", 
              type: "select", 
              label: "Marca", 
              seccion: "Información del producto", 
              options: marcas.map(marca => ({ label: marca.descripcion, value: marca.id_marca })),
              tab: "general" },
        
            // Campos para la pestaña "Combo"
            { id: "descripcion", type: "text", label: "Descripción", placeholder: "Descripción", seccion: "Información del combo", tab: "combo", required: true },
            { id: "referencia", type: "text", label: "Referencia", placeholder: "Referencia", seccion: "Información del combo", tab: "combo" },
        
            { id: "precio", type: "number", label: "Precio (Sin impuestos)", placeholder: "Precio", seccion: "Precios", tab: "combo", required: true },
            {
                id: "indicador_facturacion",
                label: "ITBIS",
                seccion: "Precios",
                tab: "combo",
                custom2: (valorActual, onChange, disabled) => (
                  <SelectIndicadorITBIS
                    value={valorActual !== null && valorActual !== undefined ? valorActual : (indicadorFacturacionActual !== null && indicadorFacturacionActual !== undefined ? indicadorFacturacionActual : 1)}
                    onChange={({ indicador_facturacion }) => onChange(indicador_facturacion)}
                    disabled={disabled}
                  />
                ),
              }, 
            { id: "precio_total", type: "number", label: "Precio total (con impuestos)", placeholder: "Precio total", seccion: "Precios", tab: "combo" },
                        {
              id: "id_cuenta_contable_venta_contado",
              label: "Cuenta de venta al contado",
              seccion: "Contabilidad",
              tab: "combo",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_venta_contado"]}
                  placeholder="Seleccionar cuenta de venta al contado"
                />
              ),
            },
            {
              id: "id_cuenta_contable_venta_credito",
              label: "Cuenta de venta a crédito",
              seccion: "Contabilidad",
              tab: "combo",
              custom: (valorActual, onClickAbrirModal) => (
                <InputCatalogoCuentas
                  valor={valorActual}
                  onClick={onClickAbrirModal}
                  nombreCuenta={nombresCuentas["id_cuenta_contable_venta_credito"]}
                  placeholder="Seleccionar cuenta de venta a crédito"
                />
              ),
            },
      //      { id: "comentario", type: "texttarea", label: "Comentario", placeholder: "Comentario", seccion: "Comentario", tab: "combo" },

            // Campos para la pestaña "Lista" agregados en el tab general
         //   { id: "id_producto", type: "select", label: "Producto", placeholder: "Producto", seccion: "Lista de producto", tab: "general" },
           //{ id: "precio_lista", type: "number", label: "Precio de lista", placeholder: "Precio de lista", seccion: "Lista de producto", tab: "general" },
          //  { id: "id_estado_lista", type: "select", label: "Estado de la lista", placeholder: "Estado de la lista", seccion: "Lista de producto", tab: "general" },

          ];
        }

        async function ObtenerProductoDetallado(id_producto) {
          try {
            const respuesta = await instanciaAxios.get(`/producto/${id_producto}`);
        
            if (respuesta.data && Object.keys(respuesta.data).length > 0) {
              return respuesta.data;
            } else {
              throw new Error("No se encontraron datos para este producto.");
            }
          } catch (error) {
            console.error("Error al obtener los datos:", error.message);
            throw error; // Volvemos a lanzar el error para que el que llame esta función pueda capturarlo.
          }
        }
  
        return{generarCamposFormulario, ObtenerProductoDetallado  }
    }

    export default FuncionesInventario;
